export const toLocalISODate = (val) => {
  if (!val) return "";
  const d = val instanceof Date ? val : new Date(val);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

export const hhmm = (d) => {
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${h}:${m}`;
};

export const isSameLocalDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const getFollowupTimeHHMM = (dateObj) => {
  const now = new Date();
  const baseTime = new Date(dateObj);

  if (isSameLocalDay(dateObj, now)) {
    const minutes = now.getHours() * 60 + now.getMinutes();
    const rounded = Math.ceil(minutes / 30) * 30;
    const clamped = Math.max(6 * 60, Math.min(18 * 60, rounded));
    baseTime.setHours(Math.floor(clamped / 60), clamped % 60, 0, 0);
    return hhmm(baseTime);
  }

  baseTime.setHours(9, 0, 0, 0);
  return hhmm(baseTime);
};
